(() => {
  const toast = document.getElementById('toast');
  let toastTimer;

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2800);
  }

  function initMenu(root = document) {
    const toggle = root.querySelector('[data-menu-toggle]') || document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu || toggle.dataset.ready === 'true') return;
    toggle.dataset.ready = 'true';
    toggle.addEventListener('click', () => {
      const isOpen = toggle.classList.toggle('open');
      menu.classList.toggle('open', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      toggle.classList.remove('open');
      menu.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    }));
  }

  function initReveal(root = document) {
    const elements = [...root.querySelectorAll('.reveal:not([data-reveal-ready])')];
    if (!elements.length) return;
    elements.forEach((element) => { element.dataset.revealReady = 'true'; });
    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('in-view'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (!entry.isIntersecting) return;
        window.setTimeout(() => entry.target.classList.add('in-view'), index * 40);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    elements.forEach((element) => observer.observe(element));
  }

  function initMarks(root = document) {
    root.querySelectorAll('.mark:not(.animate)').forEach((mark) => mark.classList.add('animate'));
  }

  function initCategoryNavigation(root = document) {
    const navigation = root.querySelector('.collection-categories') || document.querySelector('.collection-categories');
    if (!navigation || navigation.dataset.ready === 'true') return;
    navigation.dataset.ready = 'true';
    const links = [...navigation.querySelectorAll('.collection-category-link')];
    const sections = links
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter((section) => section && section.id !== 'collection');
    const activate = (hash) => {
      links.forEach((link) => link.classList.toggle('collection-category-link--active', link.getAttribute('href') === hash));
    };
    links.forEach((link) => link.addEventListener('click', () => activate(link.getAttribute('href'))));
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) activate(`#${visible.target.id}`);
    }, { rootMargin: '-28% 0px -58% 0px', threshold: [0, .1, .25] });
    sections.forEach((section) => observer.observe(section));
  }

  function initHeroShowcases(root = document) {
    root.querySelectorAll('[data-hero-showcase]:not([data-hero-ready])').forEach((showcase) => {
      showcase.dataset.heroReady = 'true';
      const slides = [...showcase.querySelectorAll('[data-hero-slide]')];
      const controls = [...showcase.querySelectorAll('[data-hero-control]')];
      const toggle = showcase.querySelector('[data-hero-toggle]');
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (slides.length < 2) return;

      let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;
      let pausedByUser = false;
      let pointerInside = false;
      let focusInside = false;

      const stop = () => {
        window.clearTimeout(timer);
        timer = undefined;
      };
      const canPlay = () => !reduceMotion && !pausedByUser && !pointerInside && !focusInside && !document.hidden;
      const schedule = () => {
        stop();
        if (!canPlay()) return;
        const duration = Number(slides[currentIndex].dataset.duration) || 6500;
        timer = window.setTimeout(() => activate(currentIndex + 1), duration);
      };
      const activate = (nextIndex) => {
        currentIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const isActive = index === currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.tabIndex = isActive ? 0 : -1;
        });
        controls.forEach((control, index) => {
          const isActive = index === currentIndex;
          control.classList.toggle('is-active', isActive);
          control.setAttribute('aria-pressed', String(isActive));
        });
        schedule();
      };
      const updateToggle = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', String(pausedByUser));
        toggle.setAttribute('aria-label', pausedByUser ? 'Relancer l’animation' : 'Mettre l’animation en pause');
        const icon = toggle.querySelector('span');
        if (icon) icon.textContent = pausedByUser ? '▶' : 'Ⅱ';
      };

      controls.forEach((control, index) => control.addEventListener('click', () => activate(index)));
      toggle?.addEventListener('click', () => {
        pausedByUser = !pausedByUser;
        updateToggle();
        schedule();
      });
      showcase.addEventListener('mouseenter', () => { pointerInside = true; stop(); });
      showcase.addEventListener('mouseleave', () => { pointerInside = false; schedule(); });
      showcase.addEventListener('focusin', () => { focusInside = true; stop(); });
      showcase.addEventListener('focusout', () => {
        window.setTimeout(() => {
          focusInside = showcase.contains(document.activeElement);
          schedule();
        }, 0);
      });
      document.addEventListener('visibilitychange', schedule);

      if (reduceMotion && toggle) toggle.hidden = true;
      updateToggle();
      activate(currentIndex);
    });
  }

  function initQuickAdd(root = document) {
    root.querySelectorAll('[data-quick-add]:not([data-ready])').forEach((form) => {
      form.dataset.ready = 'true';
      const input = form.querySelector('[data-variant-input]');
      const submit = form.querySelector('[data-add-button]');
      const price = form.closest('.product')?.querySelector('[data-card-price]');

      form.querySelectorAll('[data-variant-id]').forEach((pill) => {
        pill.addEventListener('click', () => {
          form.querySelectorAll('[data-variant-id]').forEach((item) => item.classList.remove('active'));
          pill.classList.add('active');
          input.value = pill.dataset.variantId;
          submit.disabled = false;
          submit.classList.remove('pending');
          if (price && pill.dataset.variantPrice) price.textContent = pill.dataset.variantPrice;
        });
      });

      form.addEventListener('submit', async (event) => {
        if (!input.value) {
          event.preventDefault();
          showToast('Choisis une taille avant de précommander');
          return;
        }
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        submit.disabled = true;
        submit.classList.add('loading');
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Impossible d’ajouter cette pièce.');
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
          showToast(`${result.product_title} — ajouté au panier`);
        } catch (error) {
          showToast(error.message || 'Une erreur est survenue.');
        } finally {
          submit.disabled = false;
          submit.classList.remove('loading');
        }
      });
    });
  }

  function initProductForm(root = document) {
    root.querySelectorAll('[data-product-form]:not([data-ready])').forEach((form) => {
      form.dataset.ready = 'true';
      const select = form.querySelector('[data-product-select]');
      const button = form.querySelector('[data-product-submit]');
      const price = document.querySelector('[data-product-price]');
      if (!select || !button) return;
      const update = () => {
        const option = select.options[select.selectedIndex];
        button.disabled = option.disabled;
        button.textContent = option.disabled ? 'Épuisé' : 'Précommander';
        if (price && option.dataset.price) price.textContent = option.dataset.price;
      };
      select.addEventListener('change', update);
      update();
    });
  }

  function initProductGalleries(root = document) {
    root.querySelectorAll('[data-product-gallery]:not([data-gallery-ready])').forEach((gallery) => {
      gallery.dataset.galleryReady = 'true';
      const viewport = gallery.querySelector('[data-gallery-viewport]');
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      if (!viewport || !track || !slides.length) return;

      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const currentLabel = gallery.querySelector('[data-gallery-current]');
      const dotsContainer = gallery.querySelector('[data-gallery-dots]');
      let currentIndex = 0;
      let scrollFrame;

      const slidePosition = (slide) => slide.offsetLeft - track.offsetLeft;
      const updateControls = () => {
        if (currentLabel) currentLabel.textContent = String(currentIndex + 1);
        gallery.querySelectorAll('[data-gallery-dot]').forEach((dot, index) => {
          const isActive = index === currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };
      const goTo = (index, smooth = true) => {
        currentIndex = (index + slides.length) % slides.length;
        viewport.scrollTo({ left: slidePosition(slides[currentIndex]), behavior: smooth ? 'smooth' : 'auto' });
        updateControls();
      };

      if (dotsContainer) {
        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-gallery__dot';
          dot.dataset.galleryDot = '';
          dot.setAttribute('aria-label', `Afficher la photo ${index + 1}`);
          dot.addEventListener('click', () => goTo(index));
          dotsContainer.appendChild(dot);
        });
      }

      previous?.addEventListener('click', () => goTo(currentIndex - 1));
      next?.addEventListener('click', () => goTo(currentIndex + 1));
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(currentIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(currentIndex + 1);
        }
      });
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const closest = slides.reduce((best, slide, index) => {
            const distance = Math.abs(slidePosition(slide) - viewport.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          if (closest.index !== currentIndex) {
            currentIndex = closest.index;
            updateControls();
          }
        });
      }, { passive: true });
      window.addEventListener('resize', () => goTo(currentIndex, false));
      updateControls();

      const lightbox = gallery.querySelector('[data-gallery-lightbox]');
      const zoomImage = gallery.querySelector('[data-zoom-image]');
      const zoomCounter = gallery.querySelector('[data-zoom-counter]');
      const zoomTriggers = slides.map((slide) => slide.querySelector('[data-gallery-zoom]'));
      const imageIndexes = zoomTriggers.map((trigger, index) => trigger ? index : -1).filter((index) => index >= 0);
      if (!lightbox || !zoomImage || !imageIndexes.length) return;

      const zoomPrevious = lightbox.querySelector('[data-zoom-prev]');
      const zoomNext = lightbox.querySelector('[data-zoom-next]');
      let zoomIndex = imageIndexes[0];

      const updateZoom = (index) => {
        const trigger = zoomTriggers[index];
        if (!trigger) return;
        zoomIndex = index;
        zoomImage.classList.remove('is-zoomed');
        zoomImage.src = trigger.dataset.zoomSrc;
        zoomImage.alt = trigger.dataset.zoomAlt || '';
        if (zoomCounter) zoomCounter.textContent = `${imageIndexes.indexOf(index) + 1} / ${imageIndexes.length}`;
      };
      const openZoom = (index) => {
        updateZoom(index);
        if (!lightbox.open) {
          lightbox.showModal();
          document.documentElement.classList.add('product-zoom-open');
        }
      };
      const moveZoom = (direction) => {
        const position = imageIndexes.indexOf(zoomIndex);
        updateZoom(imageIndexes[(position + direction + imageIndexes.length) % imageIndexes.length]);
      };
      const closeZoom = () => {
        if (lightbox.open) lightbox.close();
      };

      zoomTriggers.forEach((trigger, index) => trigger?.addEventListener('click', () => openZoom(index)));
      zoomPrevious?.addEventListener('click', () => moveZoom(-1));
      zoomNext?.addEventListener('click', () => moveZoom(1));
      lightbox.querySelector('[data-zoom-close]')?.addEventListener('click', closeZoom);
      zoomImage.addEventListener('click', () => zoomImage.classList.toggle('is-zoomed'));
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeZoom();
      });
      lightbox.addEventListener('close', () => {
        zoomImage.classList.remove('is-zoomed');
        document.documentElement.classList.remove('product-zoom-open');
      });
      if (imageIndexes.length < 2) {
        if (zoomPrevious) zoomPrevious.hidden = true;
        if (zoomNext) zoomNext.hidden = true;
      }
    });
  }

  function init(root = document) {
    initMenu(root);
    initReveal(root);
    initMarks(root);
    initCategoryNavigation(root);
    initHeroShowcases(root);
    initQuickAdd(root);
    initProductForm(root);
    initProductGalleries(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
